<template>

	<span ref="knd-countdown-text">Countdown</span>
		
</template>

<script>

export default {
	name: 'Countdown',
	props: ['startdate', 'enddate', 'play'],
	data() {
		return {
			end: new Date(this.enddate).getTime(),
			start: new Date(this.startdate).getTime(),
			distance: null,
			currTime: null
		}
	},
	mounted() {
		this.distance = this.end - this.start;
		this.currTime = this.distance;
	},
	methods: {
		startCountdown() {
			
			// Update the count down every 1 second
			this.interval = setInterval(() => {

				//Time to show
				this.currTime = this.currTime - 1000;

				// If the count down is finished, write some text 
				if (this.currTime <= 0) {
					clearInterval(this.interval);
					this.currTime = this.distance;
				}

			}, 1000);
		},

		getCountdownText(time) {
			// Time calculations for days, hours, minutes and seconds
			const days = Math.floor(time / (1000 * 60 * 60 * 24));
			const hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((time % (1000 * 60)) / 1000);

			return minutes + ":" + seconds.toString().padStart(2, 0);
		},

		stopCountdown() {
			clearInterval(this.interval);
		}
	},
	watch: {
		play(bool) {
			if (bool) {
				this.startCountdown();
			}
			else {
				this.stopCountdown();
			}
		},

		currTime(time) {
			this.$refs["knd-countdown-text"].innerHTML = this.getCountdownText(time);
		}
	}
}
</script>
